<template>
  <generic-modal :title="$t('appointment')" ref="generic_modal" :is_wide="true">
    <div class="form">
      <div class="columns">
        <div class="column is-4">
          <div class="field">
            <label for="" class="label">{{ $t("color") }}</label>
            <div class="control">
              <div class="select">
                <select v-model="meta.settings.color">
                  <option value="rgb(0, 209, 178)">{{ $t("teal") }}</option>
                  <option value="rgb(66, 88, 255)">{{ $t("blue") }}</option>
                  <option value="rgb(102, 209, 255);">
                    {{ $t("light blue") }}
                  </option>
                  <option value="rgb(72, 199, 142)">{{ $t("green") }}</option>
                  <option value="rgb(255, 183, 15)">{{ $t("yellow") }}</option>
                  <option value="rgb(255, 102, 133)">{{ $t("red") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('patient')"
              :placeholder="$t('select one')"
              url="/patient/catalog"
              name_field="name"
              :is_multiple="false"
              value_field="patient_id"
              @selected="set_patient"
              ref="patient_dropdown"
              :add_new="true"
              @add_new="create_patient"
            />
          </div>
          <div v-if="selected_patient">
            <div class="title is-6">
              <a :href="`/patient/${selected_patient.uuid}`">{{
                selected_patient.name
              }}</a>
            </div>
            <div class="subtitle is-6 mb-0" v-if="selected_patient.phone">
              <span>
                <span class="icon">
                  <i class="fa fa-phone"></i>
                </span>
                {{ selected_patient.phone }}
              </span>
            </div>
            <div class="subtitle is-6" v-if="selected_patient.email">
              <span>
                <span class="icon">
                  <i class="fa fa-envelope"></i>
                </span>
                {{ selected_patient.email }}
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('doctor')"
              :placeholder="$t('select one')"
              url="/patient/team/catalog"
              name_field="name"
              :is_multiple="false"
              value_field="team_member_id"
              @selected="set_doctor"
              ref="doctor_dropdown"
              :add_new="true"
              @add_new="create_doctor"
            />
          </div>
          <div v-if="selected_doctor">
            <div class="title is-6">
              <span>{{ selected_doctor.name }}</span>
            </div>
            <div class="subtitle is-6 mb-0" v-if="selected_doctor.phone">
              <span>
                <span class="icon">
                  <i class="fa fa-phone"></i>
                </span>
                {{ selected_doctor.phone }}
              </span>
            </div>
            <div class="subtitle is-6" v-if="selected_doctor.email">
              <span>
                <span class="icon">
                  <i class="fa fa-envelope"></i>
                </span>
                {{ selected_doctor.email }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('consulting room')"
              :placeholder="$t('select one')"
              url="/patient/consulting-room/catalog"
              name_field="name"
              :is_multiple="false"
              value_field="consulting_room_id"
              @selected="set_consulting_room"
              ref="consulting_room_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("start date") }}</label>
            <generic-calendar
              type="datetime"
              ref="start_date_calendar"
              display_mode="dialog"
              @selected="start_date_changed"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("end date") }}</label>
            <generic-calendar
              type="datetime"
              ref="end_date_calendar"
              display_mode="dialog"
              @selected="end_date_changed"
            />
          </div>
        </div>
      </div>
      <div class="field">
        <input
          class="is-checkradio"
          type="checkbox"
          id="chk_is_public"
          v-model="meta.is_public"
        />
        <label for="chk_is_public">{{ $t("is public") }}</label>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
    <patient-modal ref="patient_modal" />
    <team-modal ref="team_modal" />
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  confirm_deletion_dialog,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import PatientModal from "../patient_datatable/patient_modal/Index.vue";
import TeamModal from "../team_datatable/team_modal/Index.vue";
import moment from "moment";

export default {
  name: "AppointmentModal",
  components: {
    GenericModal,
    GenericCalendar,
    GenericDropdown,
    PatientModal,
    TeamModal,
  },
  data() {
    return {
      meta: { settings: {} },
      error: "",
      selected_patient: null,
      selected_doctor: null,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.patient_id ||
        !v.meta.start_date ||
        !v.meta.end_date ||
        !v.meta.doctor_id
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    create_appointment(args) {
      let v = this;
      v.set_initial_state();
      v.$refs.start_date_calendar.set_date(args.date);
      v.meta.start_date = args.date;
      let end_date = moment(args.date).add(1, "hour");
      v.$refs.end_date_calendar.set_date(end_date);
      v.meta.end_date = end_date;
      v.$refs.generic_modal.show_modal();
    },
    edit_appointment(appointment_uuid) {
      let v = this;
      v.set_initial_state();

      if (appointment_uuid) {
        // v.uuid = product_uuid;
        get("/patient/appointment", { uuid: appointment_uuid })
          .then((appointment) => {
            v.meta = appointment;
            if (appointment.start_date) {
              v.$refs.start_date_calendar.set_date(appointment.start_date);
              v.meta.start_date = moment(appointment.start_date);
            }
            if (appointment.end_date) {
              v.$refs.end_date_calendar.set_date(appointment.end_date);
              v.meta.end_date = moment(appointment.end_date);
            }
            if (appointment.patient_id)
              v.$refs.patient_dropdown.set_value(appointment.patient_id);

            if (appointment.doctor_team_member_id)
              v.$refs.doctor_dropdown.set_value(
                appointment.doctor_team_member_id
              );

            if (appointment.consulting_room_id)
              v.$refs.consulting_room_dropdown.set_value(
                appointment.consulting_room_id
              );

            v.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/patient/appointment", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/patient/appointment", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        start_date: null,
        end_date: null,
        settings: {
          name: "",
        },
      };
      v.error = "";
      v.$refs.patient_dropdown.clear();
      v.$refs.doctor_dropdown.clear();
      v.$refs.consulting_room_dropdown.clear();
      v.selected_patient = null;
      v.selected_doctor = null;
      // v.uuid = "";
    },
    start_date_changed(date) {
      let v = this;
      v.meta.start_date = date;
    },
    end_date_changed(date) {
      let v = this;
      v.meta.end_date = date;
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete appointment?"),
        v,
        () => {
          del("/patient/appointment", { uuid: v.meta.uuid })
            .then(() => {
              v.$emit("success");
              v.$refs.generic_modal.close_modal();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    set_patient(patient) {
      let v = this;
      if (patient) {
        v.selected_patient = patient;
        v.meta.patient_id = patient.patient_id;
      }
    },
    set_doctor(doctor) {
      let v = this;
      if (doctor) {
        v.selected_doctor = doctor;
        v.meta.doctor_id = doctor.team_member_id;
      }
    },
    create_patient() {
      let v = this;
      v.$refs.patient_modal.show_modal();
    },
    create_doctor() {
      let v = this;
      v.$refs.team_modal.show_modal();
    },
    set_consulting_room(consulting_room) {
      let v = this;
      if (consulting_room) {
        v.meta.consulting_room_id = consulting_room.consulting_room_id;
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
